const policyRewriteAction = {
    CREATE : 'create',

    SUBMIT : 'submit',

    DELETE : 'delete',

    START_RATING : 'start rating',

    REVERT_TO_SUBMITTED : 'revert to submitted',

    SUBMIT_FOR_ISSUANCE : 'submit for issuance',

    MARK_AS_ISSUED : 'mark as issued'

};

angular.module('gw-um-j2js')
    .constant('policyRewriteAction', policyRewriteAction);